module.exports = {
  src: __webpack_public_path__ + "assets/images/outlook_icon.ef0d0847b607e64f.svg",
  width: 26,
  height: 26,
  toString: function() { return __webpack_public_path__ + "assets/images/outlook_icon.ef0d0847b607e64f.svg"; }
};